export const GET_CUSTOM_EVENTS = 'GET_CUSTOM_EVENTS';
export const SET_CUSTOM_EVENTS = 'SET_CUSTOM_EVENTS';
export const GET_TABLE_ALERTS = 'GET_TABLE_ALERTS';
export const SET_TABLE_ALERTS = 'SET_TABLE_ALERTS';
export const SAVE_HITED_ALERTS = 'SAVE_HITED_ALERTS';
export const GET_SPEED_ALERTS = 'GET_SPEED_ALERTS';
export const SET_SPEED_ALERTS = 'SET_SPEED_ALERTS';